import ganttastic from '@infectoone/vue-ganttastic'

export default ({ app }) => {
  app.use(ganttastic)
}
